import React from 'react';
import styles from './LottoTicketSimulator.module.css';
import { Typography } from '@mui/material';
import LottoBall from '../LottoBall/LottoBall';

interface Props {
  selectedNumbers: number[];
}

const LottoTicketSimulator: React.FC<Props> = ({ selectedNumbers }) => {
  const allNumbers = Array.from({ length: 45 }, (_, i) => i + 1);
  const selectedNumbersSet = new Set(selectedNumbers);

  return (
    <div className={styles.ticketContainer}>
      <div className={styles.header}>
        <Typography variant="subtitle1" className={styles.title}>로또 6/45</Typography>
      </div>
      <div className={styles.gridContainer}>
        {allNumbers.map((number) => (
          <div key={number} className={styles.numberCell}>
            {selectedNumbersSet.has(number) ? (
              <LottoBall number={number} size="small" />
            ) : (
              <span className={styles.unselectedNumber}>{number}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LottoTicketSimulator;
